import Vue from 'vue'
import Router from 'vue-router'
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'

import Accueil from '@/components/Home'

import Go from '@/components/Go.vue'
  import Paiement from '@/components/Go/Paiement.vue'
  import Go_immatriculation from '@/components/Go/Immatriculation.vue'
  import Suivi from '@/components/Go/Suivi.vue'

import Immatriculation from '@/components/Immatriculation'
  import Carte_grise from '@/components/Immatriculation/Carte_grise'
  import Adresse from '@/components/Immatriculation/Adresse'
  import Cession from '@/components/Immatriculation/Cession'
  import Duplicata from '@/components/Immatriculation/Duplicata'
  import Etranger from '@/components/Immatriculation/Etranger'
  import Succession from '@/components/Immatriculation/Succession'
  import Matrimonial from '@/components/Immatriculation/Matrimonial'
  import Collection from '@/components/Immatriculation/Collection'
  import Autres_immat from '@/components/Immatriculation/Autres_immat'
  import Documents_immat from '@/components/Immatriculation/Documents_immat'

import Conduite from '@/components/Conduite'
  import Duplicata_permis from '@/components/Conduite/Duplicata_permis'
  import Codengo from '@/components/Conduite/Codengo'
  import International from '@/components/Conduite/International'
  import Neph from '@/components/Conduite/Neph'
  import Premiere_demande from '@/components/Conduite/Premiere_demande'
  import Renouvellement from '@/components/Conduite/Renouvellement'
  import Stages from '@/components/Conduite/Stages'
    import Book from '@/components/Conduite/Book'
  import Suspensions from '@/components/Conduite/Suspensions'
  import Documents_permis from '@/components/Conduite/Documents_permis'

import Etat_civil from '@/components/Etatcivil'
  import Cni_passeport from '@/components/EtatCivil/Cni_passeport'
  import Photomaton from '@/components/EtatCivil/Photomaton'
import Professionnels from '@/components/Professionnels'
import Contact from '@/components/Contact'
import Admin from '@/components/Admin'
import Conformite from '@/components/Conformite'

import PageNotFound from '@/components/PageNotFound'



Vue.use(Router)

//export default new Router({
const routes=[
  //________________________________________________HOME__
  {
    path: '/',
    name: 'Accueil',
    component: Accueil,
    meta:{
      title:'Les Relais Carte Grise - Gigean',
      content:'Service Carte Grise - Toutes démarches Tous véhicules - Permis de conduire - Codengo - Photomaton'
    }
  },
  //________________________________________________IMMATRICULATION__
  {
    path: '/immatriculation',
    name: 'Immatriculation',
    component: Immatriculation,
    meta:{
      parent_name:'Immatriculation',
      name:'Immatriculation',
      title:'Immatriculation - Les Relais Carte Grise',
      content:'Immatriculation - Les Relais Carte Grise'
    },
    children: [
    //carte_grise
    {
      path: 'carte_grise',
      name: 'Carte_grise',
      component: Carte_grise,
      meta:{parent_name:'Immatriculation',name:'Carte Grise',title:'Carte Grise - Les Relais Carte Grise',content:'Carte Grise - Les Relais Carte Grise',go:'/go/immatriculation'}
    },
    //adresse
    {
      path: 'adresse',
      name: 'Adresse',
      component: Adresse,
      meta:{parent_name:'Immatriculation',name:'Adresse',title:'Changement d\'adresse - Les Relais Carte Grise',content:'Changement d\'adresse - Les Relais Carte Grise',go:'/go/immatriculation?demarche=01'}
    },
    //cession
    {
      path: 'cession',
      name: 'Cession',
      component: Cession,
      meta:{parent_name:'Immatriculation',name:'Déclaration de cession',title:'Déclaration de cession - Les Relais Carte Grise',content:'Déclaration de cession - Les Relais Carte Grise'}
    },
    //duplicata
    {
      path: 'duplicata',
      name: 'Duplicata',
      component: Duplicata,
      meta:{parent_name:'Immatriculation',name:'Duplicata',title:'Duplicata Carte Grise - Les Relais Carte Grise',content:'Duplicata Carte Grise - Les Relais Carte Grise',go:'/go/immatriculation?demarche=02'}
    },
    //vehicule_etranger
    {
      path: 'vehicule_etranger',
      name: 'Vehicule_etranger',
      component: Etranger,
      meta:{parent_name:'Immatriculation',name:'Véhicule étranger',title:'Véhicule étranger - Les Relais Carte Grise',content:'Véhicule étranger - Les Relais Carte Grise'}
    },
    //successions
    {
      path: 'succession',
      name: 'Succession',
      component: Succession,
      meta:{parent_name:'Immatriculation',name:'Succession - Héritage',title:'Succession - Les Relais Carte Grise',content:'Succession - Les Relais Carte Grise',go:'/go/immatriculation?demarche=04'}
    },
    //matrimonial
    {
      path: 'matrimonial',
      name: 'Matrimonial',
      component: Matrimonial,
      meta:{parent_name:'Immatriculation',name:'Changement d\'état matrimonial',title:'Changement matrimonial - Les Relais Carte Grise',content:'Changement matrimonial - Les Relais Carte Grise',go:'/go/immatriculation?demarche=05'}
    },
    //collection
    {
      path: 'collection',
      name: 'Collection',
      component: Collection,
      meta:{parent_name:'Immatriculation',name:'Véhicule de collection',title:'Véhicules collection - Les Relais Carte Grise',content:'Véhicules collection - Les Relais Carte Grise'}
    },
    //autres_immat
    {
      path: 'autres_immat',
      name: 'Autres_immat',
      component: Autres_immat,
      meta:{parent_name:'Immatriculation',name:'Autres (immatriculation)',title:'Autres - Immatriculation - Les Relais Carte Grise',content:'Autres - Immatriculation - Les Relais Carte Grise',go:'/go/immatriculation?demarche=03'}
    }]
  },
  //_______________________________________________CONDUITE__
  {
    path: '/conduite',
    name: 'Conduite',
    component: Conduite,
    meta:{parent_name:'Conduite',name:'Conduite',title:'Conduite - Les Relais Carte Grise',content:'Conduite - Les Relais Carte Grise'},
    //neph
    children: [{
      path: 'neph',
      name: 'Neph',
      component: Neph,
      meta:{parent_name:'Conduite',name:'Demande de n° NEPH',title:'NEPH - Les Relais Carte Grise',content:'NEPH - Les Relais Carte Grise'}
    },
    //premiere_demande
    {
      path: 'premiere_demande',
      name: 'Premiere_demande',
      component: Premiere_demande,
      meta:{parent_name:'Conduite',name:'Première demande de permis de conduire suite à réussite à l\'examen',title:'Permis de conduire - Les Relais Carte Grise',content:'Permis de conduire - Les Relais Carte Grise'}
    },
    //renouvellement
    {
      path: 'renouvellement',
      name: 'Renouvellement',
      component: Renouvellement,
      meta:{parent_name:'Conduite',name:'Renouvellement de permis conduire pour fin de validité (poids lourds notamment)',title:'Renouvellement permis - Les Relais Carte Grise',content:'Renouvellement permis - Les Relais Carte Grise'}
    },
    //duplicata
    {
      path: 'duplicata',
      name: 'Duplicata_permis',
      component: Duplicata_permis,
      meta:{parent_name:'Conduite',name:'Duplicata permis de conduire',title:'Duplicata permis - Les Relais Carte Grise',content:'Duplicata permis - Les Relais Carte Grise'}
    },
    //suspensions
    {
      path: 'suspensions',
      name: 'Suspensions',
      component: Suspensions,
      meta:{parent_name:'Conduite',name:'Demande de permis suite à une suspension',title:'Suspension permis - Les Relais Carte Grise',content:'Suspension permis - Les Relais Carte Grise'}
    },
    //international
    {
      path: 'international',
      name: 'International',
      component: International,
      meta:{parent_name:'Conduite',name:'Demande de permis international',title:'Permis international - Les Relais Carte Grise',content:'Permis international - Les Relais Carte Grise'}
    },
    //codengo
    {
      path: 'codengo',
      name: 'Codengo',
      component: Codengo,
      meta:{parent_name:'Conduite',name:'Examen du code de la route - Coden\'go',title:'Codengo - Les Relais Carte Grise',content:'Codengo - Les Relais Carte Grise'}
    },
    //stages
    {
      path: 'stages',
      name: 'Stages',
      component: Stages,
      meta:{parent_name:'Conduite',name:'Stages de récupération de points',title:'Stages de récupération de points - Les Relais Carte Grise',content:'Stages de récupération de points - Les Relais Carte Grise'},
      children:[{
        path: 'book',
        name: 'Book',
        component: Book,
        meta:{title:'Réserver stage de récupération de points pas cher',content:'Réserver un stage de récupération de points pas cher. Dans toute la france'}
      }]
    }]
  },

  {//________________________________________________ETAT CIVIL______________
    path: '/etat_civil',
    name: 'Etat_civil',
    component: Etat_civil,
    meta:{parent_name:'Etat_civil',name:'Etat Civil',title:'Etat civil - Les Relais Carte Grise',content:'Etat civil - Les Relais Carte Grise'},
    children:[{
    //CNI
      path:'carte_identite_passeport',
      name:'Carte_identite_passeport',
      component: Cni_passeport,
      meta:{parent_name:'Etat Civil',name:'Carte nationale d\'identité et passeport',title:'Carte d\'identité - Passeports - Les Relais Carte Grise',content:'Carte d\'identité - Passeports - Les Relais Carte Grise',}
    },
    {
      path:'photomaton',
      name:'Photomaton',
      component: Photomaton,
      meta:{parent_name:'Etat Civil',name:'Photomaton',title:'Photomaton - Les Relais Carte Grise',content:'Photomaton - Les Relais Carte Grise'}
    }]
  },
  {
  path: '/paiement',
    name: 'Paiement',
    component: Paiement,
    meta:{
      parent_name:'Paiement',
      name:'Paiement',
      title:'',
      content:''
    }
  },
  
  //________________________________________________GO__
  {
    path: '/go',
    name: 'Go',
    component: Go,
    meta:{
      parent_name:'Go',
      name:'Services en ligne',
      title:'Services en ligne - Les Relais Carte Grise',
      content:'Services en ligne - Les Relais Carte Grise'
    },
    children: [
    //Go_immatriculation
    {
      path: 'immatriculation',
      name: 'Immatriculation',
      component: Go_immatriculation,
      meta:{parent_name:'Services en Ligne',name:'Carte Grise en ligne',title:'Carte Grise - Les Relais Carte Grise',content:'Carte Grise - Les Relais Carte Grise'}
    },
    {
      path: 'suivi',
      name: 'Suivi',
      component: Suivi,
      meta:{parent_name:'Services en Ligne',name:'Carte Grise en ligne - Suivi',title:'Carte Grise - Les Relais Carte Grise - Suivez votre dossier',content:'Carte Grise - Les Relais Carte Grise'}
    }
    ]
  },
  /*
    //Go_conduite
    {
      path: 'conduite',
      name: 'Go_conduite',
      component: Go_conduite,
      meta:{parent_name:'Go',name:'Adresse',title:'Changement d\'adresse - Les Relais Carte Grise',content:'Changement d\'adresse - Les Relais Carte Grise'}
    },
    //cession
    {
      path: 'cession',
      name: 'Cession',
      component: Cession,
      meta:{parent_name:'Immatriculation',name:'Déclaration de cession',title:'Déclaration de cession - Les Relais Carte Grise',content:'Déclaration de cession - Les Relais Carte Grise'}
    },
    //duplicata
    {
      path: 'duplicata',
      name: 'Duplicata',
      component: Duplicata,
      meta:{parent_name:'Immatriculation',name:'Duplicata',title:'Duplicata Carte Grise - Les Relais Carte Grise',content:'Duplicata Carte Grise - Les Relais Carte Grise'}
    },
    //vehicule_etranger
    {
      path: 'vehicule_etranger',
      name: 'Vehicule_etranger',
      component: Etranger,
      meta:{parent_name:'Immatriculation',name:'Véhicule étranger',title:'Véhicule étranger - Les Relais Carte Grise',content:'Véhicule étranger - Les Relais Carte Grise'}
    },
    //successions
    {
      path: 'succession',
      name: 'Succession',
      component: Succession,
      meta:{parent_name:'Immatriculation',name:'Succession - Héritage',title:'Succession - Les Relais Carte Grise',content:'Succession - Les Relais Carte Grise'}
    },
    //matrimonial
    {
      path: 'matrimonial',
      name: 'Matrimonial',
      component: Matrimonial,
      meta:{parent_name:'Immatriculation',name:'Changement d\'état matrimonial',title:'Changement matrimonial - Les Relais Carte Grise',content:'Changement matrimonial - Les Relais Carte Grise'}
    },
    //collection
    {
      path: 'collection',
      name: 'Collection',
      component: Collection,
      meta:{parent_name:'Immatriculation',name:'Véhicule de collection',title:'Véhicules collection - Les Relais Carte Grise',content:'Véhicules collection - Les Relais Carte Grise'}
    },
    //autres_immat
    {
      path: 'autres_immat',
      name: 'Autres_immat',
      component: Autres_immat,
      meta:{parent_name:'Immatriculation',name:'Autres (immatriculation)',title:'Autres - Immatriculation - Les Relais Carte Grise',content:'Autres - Immatriculation - Les Relais Carte Grise'}
    }]
  },
  */
  {
    path: '/professionnels',
    name: 'Professionnels',
    component: Professionnels,
    meta:{parent_name:'Professionnels',name:'Professionnels',title:'Professionnels - Les Relais Carte Grise',content:'Professionnels - Les Relais Carte Grise - Gigean'}
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta:{parent_name:'Contact',name:'Contact',title:'Contact - Les Relais Carte Grise',content:'Les Relais Carte Grise - Contact'}
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta:{parent_name:'Admin',name:'Admin',title:'',content:''}
  },
  {
    path: '/conformite',
    name: 'Conformité',
    component: Conformite,
    meta:{parent_name:'Conformite',name:'Certificat de conformiter',title:'Commander un certificat de conformité',content:'Commander un certificat de conformité - Rapide et pas cher'}
  },
  { path: "*", component: PageNotFound, name:'PageNotFound'}
]

const scrollBehavior = (to, from, savedPosition) =>{
  if(!to.fullPath.includes('#')){
    return { x: 0, y: 0 }
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
})

router.beforeEach((to,from,next)=>{
  //MODIF LOADER
  Nprogress.start()
  Nprogress.set(0.2)

  router.loading = true
  // console.log(router.loading)

  document.title = to.meta.title
  document.querySelector('meta[name="description"]').setAttribute('content',to.meta.content)
  // console.log(document.title)
  // console.log(document.querySelector('meta[name="description"]'))
  next()
})
router.afterEach((to,from,next) => {
  setTimeout(() => Nprogress.done(), 800)//MODIF LOADER
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js